import React from 'react';

const Textbox = ({ placeholder, value, onChange, style }) => {
  return (
    <div style={{ margin: '10px', ...style }}>
      <textarea
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        style={{
          width: '100%',
          padding: '10px',
          borderRadius: '8px',
          border: '1px solid #ccc',
          fontSize: '16px',
          boxSizing: 'border-box',
          height: '100%', 
          resize: 'none', 
        }}
      />
    </div>
  );
};

export default Textbox;
